import { ESimCardStatus, ISimCardRequest } from "../interface/ISimCardRequest";

export interface ISimCardRequestResponse {
    status?: ESimCardStatus;
}

export const getResponseToState = (response: ISimCardRequestResponse[] | undefined): ISimCardRequest[] | undefined =>
    response?.map((simCardRequest) => ({
        status: simCardRequest.status,
    }));
